import { createFileRoute } from '@tanstack/react-router';

import { InvestorOtpPage, requireLoginBranch } from '@/features/investor-login/public';

export const Route = createFileRoute('/otp')({
  beforeLoad: ({ context }) => requireLoginBranch(context.queryClient),
  component: InvestorOtpPage,
});
